
export const GET_ALLDEFAULTPRODUCT = 'GET_ALLDEFAULTPRODUCT';
export const GET_ALLDEFAULTPRODUCT_SUCCESS = 'GET_ALLDEFAULTPRODUCT_SUCCESS';
export const GET_ALLDEFAULTPRODUCT_FAILURE = 'GET_ALLDEFAULTPRODUCT_FAILURE';
export const getAllDefaultProduct = () => {
    return {
        type: GET_ALLDEFAULTPRODUCT
    }
}
export const getAllDefaultProductSuccess = (data) => {

    return {
        type: GET_ALLDEFAULTPRODUCT_SUCCESS,
        data
    }
}
export const getAllDefaultProductFailure = (data) => {
    return {
        type: GET_ALLDEFAULTPRODUCT_FAILURE,
        data
    }
}
export const PRODUCT_TEMPLATE_EDIT = 'PRODUCT_TEMPLATE_EDIT';
export const PRODUCT_TEMPLATE_EDIT_SUCCESS = 'PRODUCT_TEMPLATE_EDIT_SUCCESS';
export const PRODUCT_TEMPLATE_EDIT_FAILURE = 'PRODUCT_TEMPLATE_EDIT_FAILURE';
export const ProductTemplateEdit = (data) => {
    return {
        type: PRODUCT_TEMPLATE_EDIT,
        data
    }
}

export const ProductTemplateEditSuccess = (data) => {
    return {
        type: PRODUCT_TEMPLATE_EDIT_SUCCESS,
        data
    }
}

export const ProductTemplateEditFailure = (error) => {
    return {
        type: PRODUCT_TEMPLATE_EDIT_FAILURE,
        error
    }
}

export const SELECTED_DEFAULT_PRODUCT = 'SELECTED_DEFAULT_PRODUCT';
export const setSelectedDefaultProduct = (product) => {
    return{
        type: SELECTED_DEFAULT_PRODUCT,
        product
    }
}